// src/utils/stockAggregatorInit.js
import { db } from '../firebaseConfig';
import { doc, getDoc, getDocs, collection, writeBatch, setDoc, increment } from 'firebase/firestore';
import { isWaterMaterial } from '../utils/materialHelpers';

const CURRENT_STOCK_COLLECTION = 'current-stock';
const AGGREGATOR_DOC = 'aggregates/stock-totals';

export const initializeStockAggregator = async (showNotification) => {
    try {
        // Verificar se o agregador já existe
        const aggregatorRef = doc(db, AGGREGATOR_DOC);
        const aggregatorSnap = await getDoc(aggregatorRef);

        if (aggregatorSnap.exists()) {
            return true;
        }


        // Calcular totais de todas as entradas de estoque
        const totals = {};
        const stockSnapshot = await getDocs(collection(db, CURRENT_STOCK_COLLECTION));

        stockSnapshot.docs.forEach(d => {
            const data = d.data();
            const materialId = data.rawMaterialId;
            const quantity = parseFloat(data.quantity) || 0;
            if (materialId && quantity > 0.0001) {
                totals[materialId] = (totals[materialId] || 0) + quantity;
            }
        });

        // Criar documento agregador
        await setDoc(aggregatorRef, {
            totals,
            lastUpdated: new Date().toISOString(),
            version: 2 // Version bump for unified structure
        });

        if (showNotification) {
            showNotification('Sistema de estoque otimizado inicializado.', 'success', 3000);
        }

        return true;
    } catch (error) {
        console.error('Erro ao inicializar agregador:', error);
        if (showNotification) {
            showNotification('Erro ao inicializar sistema otimizado. Usando modo tradicional.', 'warning', 5000);
        }
        return false;
    }
};

/**
 * Updates the stock aggregator after stock operations
 * @param {string} materialId - The material ID
 * @param {number} changeAmount - Positive or negative change amount
 * @param {object} batch - Optional Firestore batch for atomic operations
 */
export const updateStockAggregator = async (materialId, changeAmount, batch = null) => {
    const aggregatorRef = doc(db, AGGREGATOR_DOC);

    if (batch) {
        // Usar o batch existente
        batch.update(aggregatorRef, {
            [`totals.${materialId}`]: increment(changeAmount),
            lastUpdated: new Date().toISOString()
        });
    } else {
        // Operação isolada
        const aggregatorSnap = await getDoc(aggregatorRef);
        if (aggregatorSnap.exists()) {
            const currentTotals = aggregatorSnap.data().totals || {};
            const newValue = (currentTotals[materialId] || 0) + changeAmount;

            if (Math.abs(newValue) < 0.0001) {
                // Remover se for zero
                const { [materialId]: removed, ...rest } = currentTotals;
                await setDoc(aggregatorRef, { totals: rest, lastUpdated: new Date().toISOString() });
            } else {
                await setDoc(aggregatorRef, {
                    totals: { ...currentTotals, [materialId]: newValue },
                    lastUpdated: new Date().toISOString()
                });
            }
        }
    }
};